import React, { useEffect, useState } from 'react';
import ArrowSVG, { Rotate } from '@components/ArrowSVG';

export interface CollapseProps {
	header: React.ReactNode | string;
	topPadding?: string;
	isOpen?: boolean;
	setIsOpen?: React.Dispatch<React.SetStateAction<boolean>>;
	isSiblingOpen?: boolean;
	setIsSiblingOpen?: React.Dispatch<React.SetStateAction<boolean>>;
	children: React.ReactNode;
}

export default function Collapse({ header, topPadding = 'py-4', isOpen = true, setIsOpen, children, isSiblingOpen, setIsSiblingOpen }: CollapseProps) {
	const [isOpenSingleton, setIsOpenSingleton] = useState(true);

	const toggleOpen = () => {
		if (!isOpen && isSiblingOpen && setIsSiblingOpen) setIsSiblingOpen(!isSiblingOpen);
		if (setIsOpen) setIsOpen(!isOpen);
		if (!setIsOpen) setIsOpenSingleton(!isOpenSingleton);
	};

	useEffect(() => {
		if (setIsOpen) setIsOpenSingleton(true);
	}, []);

	return (
		<div>
			<div data-testid='collapse-header' className={`flex justify-between items-center cursor-pointer ${topPadding} px-6`} onClick={toggleOpen}>
				<h2 className='text-lg font-semibold'>{header}</h2>
				<span data-testid='arrow' className='duration-300'>
					<ArrowSVG rotate={isOpen && isOpenSingleton ? Rotate.TOP : Rotate.BOTTOM} animation={true} />
				</span>
			</div>
			<div className={`overflow-hidden transition-all duration-300 ${isOpen && isOpenSingleton ? 'max-h-[700px]' : 'max-h-0'}`}>{children}</div>
		</div>
	);
}
